import { DecisionManager } from './DecisionManager';
export class ApiManager extends DecisionManager {
    async getCampaignsAsync(visitor) {
        return this.getDecisionApiCampaignsAsync(visitor);
    }
}
